import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Style.
 */

const StyledDiv = styled.div`
  margin-left: 6px;
`;

/*
 * Component.
 */

export const CellStarIcon: FC = () => {
  const theme = useUserTheme();

  return (
    <StyledDiv>
      <Icon name="starFilledSmall" color={theme.palette.yellow.shade40} />
    </StyledDiv>
  );
};
